import { createDataState, DataState, isDataState } from './data-state';
import { readValueAtPath } from '../address/schema-address';

export function projectState(source: DataState, path?: string): DataState {
  if (!path) {
    return source;
  }

  const value = readValueAtPath(source.data, path);

  if (isDataState(value)) {
    return value;
  }

  return createDataState(source.status, value ?? null, source.error);
}
